export const ApartmentImages = [
    {
        original: 'https://i.ibb.co/L5pBvgB/IMG-20210714-120642.jpg',
        thumbnail: 'https://i.ibb.co/zJfCN2C/IMG-20210714-120642.jpg',
    },
    {
        original: 'https://i.ibb.co/PzC8wB5/IMG-20210714-120226.jpg',
        thumbnail: 'https://i.ibb.co/jZ4Fg7L/IMG-20210714-120226.jpg',
    },
    {
        original: 'https://i.ibb.co/8bt0gHQ/IMG-20210702-162757.jpg',
        thumbnail: 'https://i.ibb.co/w7jRhf2/IMG-20210702-162757.jpg',
    },
    {
        original: 'https://i.ibb.co/4RxgwK5/IMG-20210714-120542.jpg',
        thumbnail: 'https://i.ibb.co/YBGT4Pq/IMG-20210714-120542.jpg',
    },
    {
        original: 'https://i.ibb.co/qR0dmP2/IMG-20210714-120440.jpg',
        thumbnail: 'https://i.ibb.co/THKkPFN/IMG-20210714-120440.jpg',
    },
];